import React from 'react';
import { TweenMax, Power1 } from 'gsap';
import { Transition } from 'react-transition-group';
import MenuItem from './MenuItem';
import { remCalc } from '../../util/style-util';
import { Props as MenuItemType } from './MenuItem';
import { makeStyles } from '@mui/styles';

type Props = {
  menuItems: MenuItemType[];
  show: boolean;
  activeColor: string;
  toggleMenu: () => void;
  toggleSubmenu: (string) => void;
  keepSubmenuState: boolean;
  selectedSubmenu: string;
} & any;

const MenuList = ({
  menuItems,
  show,
  toggleMenu,
  activeColor,
  keepSubmenuState,
  selectedSubmenu,
  toggleSubmenu
}: Props) => {
  const MenuItem1 = MenuItem as any;

  const classes = useStyles();

  const makeHandleClick =
    ({ onClick: additionalOnClick }, bypassToggleMenu: boolean) =>
    () => {
      if (additionalOnClick) {
        additionalOnClick();
      }

      if (!bypassToggleMenu) {
        toggleMenu();
      }
    };

  const animate: any = (list: HTMLUListElement): any => {
    TweenMax.staggerFromTo(
      list.children,
      0.3,
      {
        x: show ? -250 : 0,
        opacity: show ? 0 : 1
      },
      {
        x: show ? 0 : -250,
        opacity: show ? 1 : 0,
        ease: show ? Power1.easeOut : Power1.easeIn
      },
      0.1
    );
  };

  const renderAnimatedList = (children: any, listClassName): any => {
    return (
      <Transition in={show} timeout={200} onEnter={animate} onExit={animate} appear={true}>
        <ul className={listClassName}>{children}</ul>
      </Transition>
    );
  };

  const renderMenuItems = (menuItems: MenuItemType[], isSubmenuItem = false): any =>
    menuItems.map((item: MenuItemType | any) => (
      <MenuItem1
        name={item.name}
        key={item.name}
        icon={item.icon}
        link={item.link}
        linkType={item.linkType}
        handleItemClick={makeHandleClick(item, !!item.children)}
        activeColor={activeColor}
        subItems={
          item.children
            ? renderAnimatedList(renderMenuItems(item.children, true), classes.submenuList)
            : null
        }
        isSubmenuItem={isSubmenuItem}
        keepSubmenuState={keepSubmenuState}
        renderChildren={selectedSubmenu === item.name}
        toggleSubmenu={toggleSubmenu}
        accessibilityLabelDescription={item.accessibilityLabelDescription}
        accessibilityLabelButton={item.accessibilityLabelButton}
        disabled={item.disabled}
      />
    ));

  return renderAnimatedList(renderMenuItems(menuItems), classes.menuList);
};

const useStyles = makeStyles(() => ({
  menuList: {
    position: 'absolute',
    listStyle: 'none',
    padding: 0,
    paddingRight: remCalc(2),
    width: '100%',
    marginTop: '0px',
    '@media print': {
      display: 'none'
    },
    fontWeight: 400
  },
  submenuList: {
    listStyle: 'none',
    padding: '0',
    fontSize: '15px'
  }
}));

export default MenuList;
